import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Motion } from '@stepstone-genesis/components';
import { isServerSide } from '../../../helpers/env/isServerSide.js';
import { isFirefox } from '../../../helpers/deviceDetection.js';
export const FadeTransition = ({ transitionKey, children, sx, }) => {
    const shouldDisableAnimation = isServerSide() || isFirefox();
    return (_jsx(Motion, { initial: shouldDisableAnimation ? false : { opacity: 0 }, animate: { opacity: 1 }, exit: shouldDisableAnimation ? false : { opacity: 0 }, transition: shouldDisableAnimation ? { duration: 0 } : { duration: 0.5 }, 
        // this `willChange` is needed to prevent flickering on Safari
        sx: {
            willChange: shouldDisableAnimation ? 'auto' : 'opacity',
            ...sx,
        }, children: children }, transitionKey));
};
//# sourceMappingURL=FadeTransition.js.map